import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiStatusbarConnectedNoInternet4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNTQgMy41QzcuODUwMDQgMy41IDMuNjEwMDQgNS40IDAuNTQwMDM5IDguNDhMMTIuNTQgMjAuNUwxNy41NCAxNS40OVY3LjVIMjMuNDZDMjAuNTEgNS4wMSAxNi43IDMuNSAxMi41NCAzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEuNTQgMTcuNUgxOS41NFYxOS41SDIxLjU0VjE3LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEuNTQgOS41SDE5LjU0VjE1LjVIMjEuNTRWOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiStatusbarConnectedNoInternet4 = createIcon(
  'SignalWifiStatusbarConnectedNoInternet4',
  [
    [
      'path',
      {
        d: 'M12.54 3.5C7.85004 3.5 3.61004 5.4 0.540039 8.48L12.54 20.5L17.54 15.49V7.5H23.46C20.51 5.01 16.7 3.5 12.54 3.5Z',
        key: '1kzsj9',
      },
    ],
    ['path', { d: 'M21.54 17.5H19.54V19.5H21.54V17.5Z', key: '19qhjv' }],
    ['path', { d: 'M21.54 9.5H19.54V15.5H21.54V9.5Z', key: '1dz9ee' }],
  ],
);

export default SignalWifiStatusbarConnectedNoInternet4;
